import { TableConfig } from './table-config';

export class MapperTableConfig extends TableConfig {
  queryTitle?: string;
  /**
   * 表格数据接口地址
   */
  queryTable?: string;
  /**
   * 表头请求参数, mapperCode,用于后端识别对应mapper
   */
  titleParams?: { [key: string]: any};
  /**
   * 是否可选择显示列
   */
  isCollapse?: boolean;
  /**
   * 是否编辑
   */
  isEdit?: boolean;
  /**
   * 是否单个删除
   */
  isDelete?: boolean;
  /**
   * 是否批量删除
   */
  isBatchDelete?: boolean;
  /**
   * 是否显示添加按钮
   */
  isAdd?: boolean;
  /**
   * 是否显示导出按钮
   */
  isExport?: boolean;
  /**
   * 是否显示导入按钮
   */
  isImport?: boolean;
  /**
   * 单选删除配置
   */
  deleteConfig?: {
    key?: string,
    url?: string,
    clickEvent?: (...deleteConfig) => any;
  };
  /**
   * 是否显示列搜索
   */
  isColSearch?: boolean;
  /**
   * 编辑按钮配置
   */
  editConfig?: {
    clickEvent?: any;
    mapperUrl?: string,
    mapperParams?: any,
  };
  /**
   * 添加按钮配置
   */
  // clickEvent?: (...addConfig) => {}
  addConfig?: {
    params?: {},
    url?: string,
    mapperUrl?: string,
    mapperParams?: any,
    clickEvent?: (...addConfig) => any
  };
  /**
   * 批量删除配置
   */
  batchDeleteConfig?: {
    key?: string,
    url?: string
    clickEvent?: (...batchDeleteConfig) => any;
  };
  /**
   * 导出配置
   */
  exportConfig?: {
    // key?: string,
    // url?: string,
    data?: Array<{label?: string, value?: string, url?: string}>,
    urls?: any[],
    params?: object,
    clickEvent?: (...exportConfig) => any;
  };
  /**
   * 导入配置
   */
  importConfig?: {
    params?: {},
    url?: {},
    clickEvent?: (...importConfig) => any
  };
  constructor() {
    super();
    // this.isAdd = true;
    // this.isDelete = true;
    this.isCollapse = true;
    this.isEdit = true;
    // this.isExport = true;
    // this.isImport = false;
    this.isBatchDelete = false;
    this.isColSearch = true;
    this.exportConfig = {
      params: {},
      data: [
        // {label: '导出勾选报表', value: 'checkedRows'},
        // {label: '导出全部报表', value: 'checkedAllRow'},
        // {label: '导出勾选二维码', value: 'checkedCodes'},
        // {label: '导出全部二维码', value: 'checkedAllCodes'},
      ],
    };
  }
}
